
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';
// 配置全局loading有遮罩层，防止误操作
import {Spin} from 'view-design';
import MSG from '@/assets/message/message/index';

// 激活的 loading 列表，用于判断是否需要创建新的 loading
const activeLoadings = new Map();
// 当前展示的 loading 文案，用于判断是否需要刷新 Spin
let currentLoadingText = null;
// Spin.hide 内部有 500ms 销毁延迟，保留短延迟以支持链式请求取消 hide
let pendingHideTimer = null;

// 创建 loading 遮罩的 render 函数
function createLoadingRender(text) {
  return (h) => {
    const txt = text || aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000514');
    return h(
      'div', {
        style: {
          zIndex: 9999,
          backgroundColor: '#fff',
          padding: '32px 30px',
          borderRadius: '12px',
          textAlign: 'center'
        }
      },
      [
        h('Icon', {
          class: 'loading_modal_style',
          props: {type: 'ios-loading', size: 28}
        }),
        h('div', {style: {marginTop: '5px', fontSize: '17px'}}, txt)
      ]
    );
  };
}

// 直接更新 Spin 遮罩的文本内容（绕过 Spin.show 的实例守卫）
function updateSpinText(text) {
  const textEl = document.querySelector('.loading_modal_style + div');
  if (textEl) {
    textEl.textContent = text || aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000514');
  }
}

// 直接显示 Spin 遮罩（手动调用，不经过 token 追踪）
export function startLoading(text) {
  Spin.show({
    render: createLoadingRender(text || aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000514'))
  });
}

// 直接隐藏 Spin 遮罩（手动调用）
export function endLoading() {
  Spin.hide();
}

// 显示 loading（兼容旧调用：scope 参数兼容手动调用场景）
export function showLoadingModal(text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000514'), token) {
  const key = token || 'global';
  if (activeLoadings.has(key)) return key;
  const wasEmpty = activeLoadings.size === 0;
  activeLoadings.set(key, {text});
  if (wasEmpty) {
    // 有 pending 的 hide → 取消关闭，直接更新文案
    if (pendingHideTimer) {
      clearTimeout(pendingHideTimer);
      pendingHideTimer = null;
      if (currentLoadingText !== null && currentLoadingText !== text) {
        updateSpinText(text);
      }
    } else {
      // 正常首次展示
      startLoading(text);
    }
  } else if (currentLoadingText !== null && currentLoadingText !== text) {
    // 已有活跃 token 且文案变化 → 原地更新文案，不销毁重建
    updateSpinText(text);
  }
  
  currentLoadingText = text;
  return key;
}

// 隐藏 loading（兼容旧调用：hideLoadingModal(status) 传数字作为第一个参数）
export function hideLoadingModal(token, status = 200) {
  if (typeof token === 'number') {
    status = token;
    token = 'global';
  }
  const key = token || 'global';
  if (!activeLoadings.has(key)) return;
  activeLoadings.delete(key);
  // 只有 504 或 500 才显示请求异常
  if (status === 504 || status === 500) {
    MSG.error({
      content: status === 504 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001690') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001691'),
      duration: 5,
      level: 1,
      closable: true,
    });
  }
  // 延迟关闭 Spin，给链式请求一个窗口期取消关闭
  if (activeLoadings.size === 0) {
    if (pendingHideTimer) clearTimeout(pendingHideTimer);
    pendingHideTimer = setTimeout(() => {
      pendingHideTimer = null;
      if (activeLoadings.size === 0) {
        endLoading();
        currentLoadingText = null;
      }
    }, 50);
  }
}

// 强制清理所有 loading（路由切换/取消请求）
export function clearAllLoading() {
  if (pendingHideTimer) {
    clearTimeout(pendingHideTimer);
    pendingHideTimer = null;
  }
  activeLoadings.clear();
  currentLoadingText = null;
  Spin.hide();
}